export default () => {
  const LEGACY_VERSION = "2"
  // Using JSON.stringify ensures that projects not exposing VUE_APP_VERSION variable can compile
  const vueVersion = JSON.parse(
    JSON.stringify(process.env.VUE_APP_VERSION) || LEGACY_VERSION
  )
  return vueVersion === "3"
}
